/* AP 6.0 — « Composer mon lot » (sections/ap-lot.liquid).
   Grille : cartes rendues en Liquid via la Section Rendering API (/collections/<h>?section_id=ap-lot, /search?…&section_id=ap-lot).
   Lot : 3 posters, format commun (m/l/xl), cadre commun ('' | noir | blanc | bois-clair | bois-fonce).
   Prix : /products/<handle>.js (prix du marché courant) + prix des cadres window.AP_FRAMES (ap-globo-data).
   Total affiché = somme des 3 lignes − la moins chère (remise automatique « 3ᵉ offert », 1 par commande).
   Ajout : AP.addItems (3 lignes, charge utile Globo pour le cadre) → ouvre le tiroir. */
(function () {
  'use strict';
  var box = document.querySelector('[data-ap-lot]');
  if (!box || !window.AP) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var T = {};
  try { T = JSON.parse(box.querySelector('[data-ap-lot-i18n]').textContent); } catch (e) {}
  var $ = function (s) { return box.querySelector(s); };
  var grid = $('[data-ap-lot-grid]'), more = $('[data-ap-lot-more]'), q = $('[data-ap-lot-q]');
  var slots = $('[data-ap-lot-slots]'), sum = $('[data-ap-lot-sum]'), add = $('[data-ap-lot-add]');
  var sub = $('[data-ap-lot-sub]'), err = $('[data-ap-lot-err]'), bar = $('[data-ap-lot-bar]');
  var chips = Array.prototype.slice.call(box.querySelectorAll('.ap-lot-chips [data-url]'));
  var params = new URLSearchParams(location.search);
  var S = { size: 'm', frame: '', picks: [], src: chips[0] ? chips[0].dataset.url : '', page: 1, q: '', busy: false, used: false };
  if (/^(m|l|xl)$/.test(params.get('s') || '')) S.size = params.get('s');
  if (AP.cadreId(params.get('f') || '')) S.frame = AP.cadreId(params.get('f'));
  var cache = {};

  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var plural = function (k, n) { return n === 1 ? T[k + '1'] : String(T[k + '2'] || '').replace('2', n); };
  var img = function (u, w) { return u ? u.replace(/([?&])width=\d+/, '$1width=' + w) + (/[?&]width=/.test(u) ? '' : (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w) : ''; };

  /* poster encadré côté JS (même structure que snippets/poster-encadre, image carrée 1000×1000) */
  function framed(src, id, alt) {
    return '<span class="ap-fp ap-sq' + (id ? '' : ' ap-fp-none') + '" data-poster-encadre data-frame-fixed><span class="ap-fp-win"><img class="ap-fp-art" src="' + esc(img(src, 300)) + '" alt="' + esc(alt || '') + '" width="300" height="300" loading="lazy"></span>' +
      (id ? '<img class="ap-fp-frame" src="' + esc(AP.frameUrl(id)) + '" alt="" aria-hidden="true" width="592" height="814">' : '') + '</span>';
  }

  function product(h) {
    if (cache[h]) return cache[h];
    cache[h] = fetch(root + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (p) {
        var v = {};
        p.variants.forEach(function (x) { var k = AP.sizeKey(x.title || x.option1); if (k && !v[k]) v[k] = { id: x.id, price: x.price, available: x.available }; });
        var im = p.featured_image || (p.images && p.images[0]) || '';
        if (im && im.indexOf('//') === 0) im = 'https:' + im;
        return { h: p.handle, req: h, t: p.title, img: im, v: v };
      });
    cache[h].catch(function () { delete cache[h]; });
    return cache[h];
  }

  var unit = function (p) {
    var v = p.v[S.size]; if (!v || !v.available) return null;
    return v.price + (S.frame ? AP.framePrice(S.size, S.frame) : 0);
  };
  var picked = function (h) { for (var i = 0; i < S.picks.length; i++) if (S.picks[i].h === h || S.picks[i].req === h) return i; return -1; };

  function drawGrid() {
    var full = S.picks.length >= 3;
    grid.querySelectorAll('.ap-lot-card').forEach(function (c) {
      var i = picked(c.dataset.h), on = i > -1;
      c.setAttribute('aria-pressed', on);
      c.disabled = full && !on;
      c.querySelector('.ap-lot-card__tick').textContent = on ? i + 1 : '+';
    });
    AP.setCadre(S.frame, grid);
  }

  function drawBox() {
    var n = S.picks.length, total = 0, min = Infinity, ok = n === 3, sizeLbl = '';
    var names = (window.AP_FRAMES && AP_FRAMES.names) || {};
    slots.innerHTML = [0, 1, 2].map(function (i) {
      var p = S.picks[i];
      if (!p) return '<div class="ap-lot-slot">' + esc(i === 2 && !S.used ? T.slot3 : String(T.slot || '').replace('%n', i + 1)) + '</div>';
      var u = unit(p);
      if (u === null) ok = false; else { total += u; min = Math.min(min, u); }
      return '<div class="ap-lot-slot is-full">' + framed(p.img, S.frame, p.t) +
        '<button type="button" class="ap-lot-slot__x" data-rm="' + esc(p.h) + '" aria-label="' + esc(String(T.remove || '').replace('%t', p.t)) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
        (u === null ? '<span class="ap-lot-slot__na">' + esc(T.na) + '</span>' : (i === 2 && !S.used ? '<span class="ap-pill ap-pill-violet">' + esc(T.gift) + '</span>' : '')) + '</div>';
    }).join('');
    box.querySelectorAll('.ap-lot-seg [data-s]').forEach(function (b) { var on = b.dataset.s === S.size; b.setAttribute('aria-checked', on); if (on) sizeLbl = b.dataset.dim; });
    $('[data-ap-lot-size-lbl]').textContent = sizeLbl;
    box.querySelectorAll('.ap-lot-sw [data-f]').forEach(function (b) {
      var f = b.dataset.f, pr = f ? AP.framePrice(S.size, f) : 0;
      b.setAttribute('aria-checked', f === S.frame);
      b.title = (names[f] || '') + (pr ? ' (+' + AP.money(pr) + ')' : '');
    });
    var fp = S.frame ? AP.framePrice(S.size, S.frame) : 0;
    $('[data-ap-lot-frame-lbl]').textContent = (names[S.frame] || '') + (fp ? ' (+' + AP.money(fp) + ')' : '');
    sub.textContent = n === 3 ? (S.used ? T.full : T.complete) : plural('left', 3 - n);
    var lbl = String(T.lines || '').replace('%s', S.size.toUpperCase()) + (S.frame ? ' · ' + (names[S.frame] || '') : '');
    var off = n === 3 && ok && !S.used;
    if (n && isFinite(min)) {
      sum.innerHTML = '<div><span>' + esc(n === 3 ? lbl : lbl.replace('3 ×', n + ' ×')) + '</span><span>' + AP.money(total) + '</span></div>' +
        (off ? '<div class="is-off"><span>' + esc(T.free) + '</span><span>−' + AP.money(min) + '</span></div>' : '') +
        '<div class="is-tot"><span>' + esc(T.total) + '</span><span>' + AP.money(off ? total - min : total) + '</span></div>' +
        (S.used ? '<p class="ap-lot-used">' + esc(T.used) + '</p>' : '');
    } else sum.innerHTML = '';
    add.disabled = !ok || S.busy;
    add.textContent = n < 3 ? plural('choose', 3 - n) : T.add;
    if (bar) {
      bar.innerHTML = '<span class="ap-lot-mbar__th">' + [0, 1, 2].map(function (i) {
        var p = S.picks[i]; return '<i' + (p ? ' class="is-full" style="background-image:url(\'' + esc(img(p.img, 100)) + '\')"' : '') + '></i>';
      }).join('') + '</span><span class="ap-lot-mbar__t">' + esc(String(T.count || '').replace('%n', n)) + '<b>' + (n && isFinite(min) ? AP.money(off ? total - min : total) : '&nbsp;') + '</b></span>' +
        (n === 3 ? '<button type="button" class="ap-btn ap-btn-dark" data-ap-lot-add' + (ok && !S.busy ? '' : ' disabled') + '>' + esc(T.addShort) + '</button>'
          : '<a class="ap-btn ap-btn-line" href="#ApLotBox">' + esc(T.mySet) + '</a>');
    }
  }
  var draw = function () { drawGrid(); drawBox(); };

  /* chargement de la grille (section rendering) */
  function load(url, append) {
    grid.classList.add('is-loading');
    var u = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=ap-lot';
    return fetch(u).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (html) {
      var d = new DOMParser().parseFromString(html, 'text/html').querySelector('.ap-lot-data');
      var cards = d ? d.querySelectorAll('.ap-lot-card') : [];
      var next = d && d.querySelector('[data-next]');
      if (!append) grid.innerHTML = '';
      Array.prototype.forEach.call(cards, function (c) { if (!grid.querySelector('[data-h="' + c.dataset.h + '"]')) grid.appendChild(document.importNode(c, true)); });
      if (!grid.children.length) grid.innerHTML = '<p class="ap-lot-empty">' + esc(T.none) + '</p>';
      S.next = next ? next.getAttribute('data-next') : '';
      more.hidden = !S.next;
      drawGrid();
    }).catch(function () { if (!append) grid.innerHTML = '<p class="ap-lot-empty">' + esc(T.none) + '</p>'; })
      .then(function () { grid.classList.remove('is-loading'); });
  }
  S.next = S.src ? S.src + (S.src.indexOf('?') > -1 ? '&' : '?') + 'page=2' : '';

  function pick(h, card) {
    var i = picked(h);
    if (i > -1) { S.picks.splice(i, 1); draw(); return Promise.resolve(); }
    if (S.picks.length >= 3) return Promise.resolve();
    if (card) card.classList.add('is-busy');
    return product(h).then(function (p) {
      if (picked(p.h) < 0 && S.picks.length < 3) S.picks.push(p);
      err.textContent = '';
    }).catch(function () { err.textContent = T.error; })
      .then(function () { if (card) card.classList.remove('is-busy'); draw(); });
  }

  box.addEventListener('click', function (e) {
    var c = e.target.closest('.ap-lot-card'), chip = e.target.closest('.ap-lot-chips [data-url]');
    var rm = e.target.closest('[data-rm]'), s = e.target.closest('.ap-lot-seg [data-s]'), f = e.target.closest('.ap-lot-sw [data-f]');
    var ad = e.target.closest('[data-ap-lot-add]');
    if (c && !c.disabled) pick(c.dataset.h, c);
    else if (chip) {
      chips.forEach(function (x) { x.setAttribute('aria-pressed', x === chip); });
      S.src = chip.dataset.url; S.q = ''; q.value = '';
      load(S.src, false);
    } else if (rm) { S.picks = S.picks.filter(function (p) { return p.h !== rm.dataset.rm; }); draw(); }
    else if (s) { S.size = s.dataset.s; drawBox(); }
    else if (f) { S.frame = f.dataset.f; draw(); }
    else if (ad && !ad.disabled) addLot();
  });
  more.addEventListener('click', function () { if (S.next) load(S.next, true); });

  var tq;
  q.addEventListener('input', function () {
    clearTimeout(tq);
    tq = setTimeout(function () {
      var v = q.value.trim();
      if (v === S.q) return;
      S.q = v;
      if (v.length < 2) {
        var on = chips.filter(function (x) { return x.getAttribute('aria-pressed') === 'true'; })[0] || chips[0];
        if (on) { on.setAttribute('aria-pressed', 'true'); load(on.dataset.url, false); }
        return;
      }
      chips.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      load(box.dataset.search + '?q=' + encodeURIComponent(v) + '&type=product&options%5Bprefix%5D=last', false);
    }, 300);
  });
  q.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });

  function addLot() {
    if (S.picks.length !== 3 || S.busy) return;
    var items = [];
    for (var i = 0; i < 3; i++) {
      var v = S.picks[i].v[S.size]; if (!v || !v.available) return;
      items.push({ id: v.id, qty: 1, size: S.size, frame: S.frame });
    }
    S.busy = true; err.textContent = ''; drawBox();
    AP.addItems(items).then(function () { S.picks = []; })
      .catch(function () { err.textContent = T.error; })
      .then(function () { S.busy = false; draw(); });
  }

  /* poster offert déjà utilisé dans le panier (1 par commande) → le lot est affiché sans remise */
  var tu;
  function checkUsed() {
    clearTimeout(tu);
    tu = setTimeout(function () {
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        var u = (c.items || []).some(function (i) {
          return (i.line_level_discount_allocations || []).some(function (a) { return a.amount > 0 && a.discount_application && a.discount_application.title === '2+1'; });
        });
        if (u !== S.used) { S.used = u; drawBox(); }
      }).catch(function () {});
    }, 250);
  }
  checkUsed();
  document.addEventListener('ap:cart', checkUsed);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, checkUsed);

  /* préremplissage ?p=h1,h2,h3 */
  var pre = (params.get('p') || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean).slice(0, 3);
  draw();
  pre.reduce(function (pr, h) { return pr.then(function () { return pick(h); }); }, Promise.resolve());
})();
